import React, {useContext} from "react";
import './Sidebar.css';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import {PortfolioContext} from '../../App';


const Sidebar = () => {
    const portfolio = useContext(PortfolioContext);
    const github = portfolio['github'] || "";
    const instagram = portfolio['instagram'] || "";
    const linkedin = portfolio['linkedin'] || "";
    const tele = portfolio['tele'] || "";
    
    return (
        <>
            <div className="right-sidebar">
                <div className="email-div">
                    <a href="mailto:py.usman.ali@gmail.com" className="sidebar-email" > py.usman.ali@gmail.com  </a>
                </div>
                <hr style={{height: '100px', background: '#a8b2d1' }}></hr>
            </div>  
            <div className="left-sidebar">
                <div className="icons-div">
                    <div className="left-icons">
                        <a href={github}> <GitHubIcon sx={{ 
                            color: "#a8b2d1", 
                            "&:hover": {
                                color: "#37DBB2",
                            },  }} /> 
                        </a>
                        <a href={linkedin}> <LinkedInIcon sx={{ 
                            color: "#a8b2d1", 
                            "&:hover": {
                                color: "#37DBB2",
                            },  }} /> </a>
                        <a href={instagram}> <InstagramIcon sx={{ 
                            color: "#a8b2d1", 
                            "&:hover": {
                                color: "#37DBB2",
                            },  }} />  </a>
                        <a href={tele}> <ContactPageIcon sx={{ 
                            color: "#a8b2d1", 
                            "&:hover": {
                                color: "#37DBB2",
                            },  }} />  </a>
                    </div>
                    <hr style={{height: '100px', background: '#a8b2d1' }}></hr>
                </div>
            </div>
        </>
       

    )
}

export default Sidebar;
